import { motion } from "framer-motion";
import { Reveal, SectionLabel } from "../../lib/motion";
import { PROPERTY_STORY } from "../../data";

export const PropertyStory = () => {
  return (
    <section className="py-24 md:py-32 bg-navy text-white overflow-hidden scroll-mt-20">
      <div className="max-w-5xl mx-auto px-6 md:px-10">
        <Reveal className="max-w-2xl">
          <span className="label-caps text-xs text-water">Property Story</span>
          <h2 className="font-serif text-4xl md:text-5xl font-light mt-4 leading-tight">
            The history behind the homesite
          </h2>
          <p className="mt-5 text-white/70 leading-relaxed">
            A transparent account of the property’s timeline — from its early history to a
            sale-ready state backed by comprehensive documentation.
          </p>
        </Reveal>

        <div className="mt-16 relative">
          <div className="absolute left-[15px] md:left-1/2 md:-translate-x-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-water/60 via-white/20 to-transparent" />
          <div className="space-y-8">
            {PROPERTY_STORY.map((item, i) => (
              <motion.div
                key={i}
                data-testid={`story-item-${i}`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.06, ease: [0.16, 1, 0.3, 1] }}
                className={`relative flex items-start gap-6 md:w-1/2 ${
                  i % 2 === 0 ? "md:ml-auto md:pl-12" : "md:mr-auto md:flex-row-reverse md:pr-12 md:text-right"
                }`}
              >
                <div className={`relative z-10 shrink-0 w-8 h-8 rounded-full bg-water flex items-center justify-center ring-4 ring-navy shadow-lg ${i % 2 === 0 ? "md:-ml-[64px]" : "md:-mr-[64px]"}`}>
                  <div className="w-2 h-2 rounded-full bg-white" />
                </div>
                <div className="pt-0.5">
                  {item.year !== "—" && (
                    <div className="font-serif text-2xl text-water">{item.year}</div>
                  )}
                  <p className="mt-1 text-white/90 leading-relaxed">{item.text}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
